import { render, staticRenderFns } from "./AddContentBlockMarker.vue?vue&type=template&id=03b6697c&scoped=true"
import script from "./AddContentBlockMarker.vue?vue&type=script&lang=js"
export * from "./AddContentBlockMarker.vue?vue&type=script&lang=js"
import style0 from "./AddContentBlockMarker.vue?vue&type=style&index=0&id=03b6697c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b6697c",
  null
  
)

export default component.exports